import { useEffect, useState } from "react";
import { COUNTRIES_API_URL } from "../ResourcesModal.constants";

export const useCountries = () => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await fetch(COUNTRIES_API_URL);
        const data = await res.json();
        const countryList = data.map((c) => c.name.common).sort();
        setCountries(countryList);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountries();
  }, []);

  return countries;
};
